import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Button } from '@src/components/Button';

export const ModalActions = ({ actions, isPaddingDisabled }) => {
  return (
    <div
      className={classnames('subscription-modal__buttons', {
        'subscription-modal__buttons--padding-none': isPaddingDisabled,
      })}
    >
      {(actions || []).map(({ name, onClick, isDisabled, buttonAppearance }, i) => {
        return (
          <Button
            appearance={buttonAppearance || undefined}
            className={classnames({ 'subscription-modal__button-margin-left': i > 0 })}
            isDisabled={isDisabled}
            key={i}
            onClick={onClick}
          >
            {name}
          </Button>
        );
      })}
    </div>
  );
};

ModalActions.defaultProps = {
  actions: [],
  isPaddingDisabled: false,
};

ModalActions.propTypes = {
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      buttonAppearance: PropTypes.string,
      isDisabled: PropTypes.bool,
      name: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
    }),
  ),
  isPaddingDisabled: PropTypes.bool,
};
